/**
 * Authentication route constants and mappings
 */

export const AUTH_ROUTES = {
	SIGNUP: '/auth/signup',
	SIGNUP_OTP: '/auth/signup/otp',
	SIGNIN: '/auth/signin',
	SIGNIN_OTP: '/auth/signin/otp',
	FORGET_PASSWORD: '/auth/forget-password',
}

export const AUTH_STEPS = {
	SIGNUP: 0,
	SIGNUP_OTP: 1,
	SIGNIN: 2,
	SIGNIN_OTP: 3,
	FORGET_PASSWORD: 4,
}

export const AUTH_PATHS = {
	signup: 'signup',
	'signup-otp': 'signup-otp',
	signin: 'signin',
	'signin-otp': 'signin-otp',
	'forget-password': 'forget-password',
}

export const OTP_TIMER_DURATION = 120 // seconds

export const VALIDATION_STATUS = {
	NORMAL: 'normal',
	VALID: 'valid',
	ERROR: 'error',
}

